<template>
    <div class="map_panel">
        <div id='GDMap' class="map_container"></div>
        <div class="popup_panel" v-show="showPopup">
            <div class="popup_title" :class="{ plus: popupInfo.type == 3 || (popupInfo.type == 2 && popupInfo.level >= 3) }"
                ref="popup1">
                <div class="list_group" v-if="popupInfo.type == 1 || (popupInfo.type == 2 && popupInfo.level < 3)">
                    <div class="group_cont">
                        <div class="group_title">
                            <div class="title_text">{{ popupInfo.type == 1 ? '服务人员信息' : '终端信息' }}</div>
                        </div>
                        <div class="list_panel">
                            <div class="list_item">
                                <div class="item_title">地区：</div>
                                <div class="item_num">{{ popupInfo.areaName }}</div>
                            </div>
                            <div class="list_item">
                                <div class="item_title">数量：</div>
                                <div class="item_num">{{
                                    popupInfo.type == 1 ? setNum(popupInfo.medBrokerNum) :
                                    setNum(popupInfo.terminalNum)
                                }}</div>
                            </div>
                            <div class="list_item" v-if="popupInfo.type == 1 && channelName">
                                <div class="item_title">会员渠道：</div>
                                <div class="item_num active to_detail to_channel">{{ channelName }}</div>
                            </div>
                        </div>
                        <div class="info_btns">
                            <el-button size="mini" class="drill_btn">下钻</el-button>
                        </div>
                    </div>
                </div>
                <div class="list_group" v-if="popupInfo.type == 3 || (popupInfo.type == 2 && popupInfo.level >= 3)">
                    <div class="group_cont">
                        <div class="group_title">
                            <div class="title_text to_detail_page">{{ popupInfo.name }}</div>
                            <div class="title_addr">{{ popupInfo.address }}</div>
                            <div class="title_tags">
                                <span class="tag_text" v-for="item in popupInfo.tags">{{ tagValue(item) }}</span>
                            </div>
                        </div>
                        <div class="list_panel">
                            <div class="list_item" v-for="item in popupInfo.list">
                                <div class="item_title">{{ item.label }}：</div>
                                <div class="item_num to_detail to_term"
                                    :class="{ active: item.field == 'newestMaintainStaffName' }">{{ item.value }}</div>
                            </div>
                            <div class="list_item" v-if="channelName && popupInfo.type == 2">
                                <div class="item_title">会员渠道：</div>
                                <div class="item_num active to_detail to_channel">{{ channelName }}</div>
                            </div>
                        </div>
                        <!-- <div class="info_btns" v-if="popupInfo.type == 3 && popupInfo.level < 3">
                            <el-button size="mini" class="drill_btn">下钻</el-button> 
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
window._AMapSecurityConfig = {
    securityJsCode: 'b089de752721d377e1c30b216c978e40',
}
import AMapLoader from '@amap/amap-jsapi-loader';
import {
    changeNum,
    typeFilter,
    formatInt,
    setColor,
    getOrgMapData,
    getVisitMapData,
    getPointMapData,
    setBaseInfo,
} from '@/api/portrait.js'
// 监听dom变化
import ElementResizeDetectorMaker from "element-resize-detector";
export default {
    props: {
        searchType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            map: null,
            mapZoom: 4.5,
            mapCenter: [104.188488, 34.302032],
            polygonOptions: null,
            showPopup: false,
            infoWindow: null,
            popupInfo: {
                areaName: '',
                medBrokerNum: '',
                fullBrokerNum: '',
                partBrokerNum: '',
                terminalNum: '',
                channelNum: ''
            },
            layerData: null,
            layerList: [],
            listParams: {
                level: 0,
                type: [],
                code: '',
                terminalType: [],
                damId: ''
            },
            refreshLayer: true,
            options: null,
            currFeature: null,
            tipsNotify: null,
            prevFeature: [],
            disCountry: null,
            districtSearch: null,
            channelName: '',
            channelMapInfo: {
                params: {},
                data: null,
                prevFeature: []
            },
            currMouseInfo: {},
            prevMouseInfo: null,
            hlLayer: null,
            isSearchPosit: false,
            toFit: false
        }
    },
    mounted() {
        this.currMouseInfo.zoom = this.mapZoom
        this.initMap()
    },
    methods: {
        setNum(val) {
            return changeNum(val)
        },
        tagValue(row) {
            return typeFilter(row)
        },
        // 左下角信息提示框
        openNotify() {
            this.tipsNotify = this.$notify({
                duration: 0,
                offset: 0,
                position: 'bottom-left',
                dangerouslyUseHTMLString: true,
                message: `<div class="tips_panel" style="width: 300px; position: relative; padding-bottom: 30px;margin-left: -15px">
                                <div class="panel_title" style="color: #212121;margin-bottom: 5px;">
                                    <img class="title_icon" src="${require('@/assets/map/map_tips_icon.png')}" alt="" style="width: 24px; height: 24px; margin-right: 5px; vertical-align: middle;">
                                    <span style="font-size: 16px">交互提示</span>
                                </div>
                                <div class="panel_con" style="color: #212121; font-size: 14px; padding-left: 35px">【双击】地图查看下一层级信息。</div>
                                <button class="notify_close_btn" style="background: #FFFFFF; color: #4FA1A4; font-size: 12px; border: 1px solid rgba(79,161,164,1); border-radius: 2px; position: absolute; right: 0; bottom: 0;">我知道了</button>
                            </div>`,
            });
            this.$nextTick(() => {
                const closeBtn = document.querySelectorAll('.notify_close_btn')
                closeBtn[0].onclick = (e) => {
                    //在这里做点击的操作
                    this.tipsNotify.close()
                }
                const aside = document.querySelectorAll('.el-main')[0]
                const notification = document.querySelectorAll('.el-notification')[0]
                notification.style.left = (aside.offsetLeft + 15) + 'px'

                let erd = ElementResizeDetectorMaker();
                erd.listenTo(aside, element => {
                    notification.style.left = (element.offsetLeft + 15) + 'px';
                });
            })
        },
        // 初始化高德地图
        initMap() {
            if (this.map) {
                this.getLayerList()
            } else {
                AMapLoader.load({
                    "key": "762365115a99c4dee64cbe8a3b1d37a0", // 申请好的Web端开发者Key，首次调用 load 时必填
                    "version": "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                    "plugins": ['AMap.GeoJSON', 'AMap.DistrictSearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
                }).then((AMap) => {
                    this.loadMap()
                }).catch(e => {
                    console.log(e);
                })
            }
        },
        // 加载地图
        loadMap() {
            let _this = this
            this.map = new AMap.Map('GDMap', {
                viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
                zoom: _this.mapZoom, //初始化地图层级
                center: _this.mapCenter, //初始化地图中心点
                defaultCursor: 'pointer',
                zooms: [4, 20],
                doubleClickZoom: false,
                mapStyle: 'amap://styles/ac2784f576e9f377d463097fd978aec6',
                layers: []
            });
            // 限制可视范围
            var bounds = [73.33, 3.51, 135.05, 53.33];
            this.map.setLimitBounds(bounds);
            // 加载 图层
            // this.$emit('openLoading', true)
            this.getLayerList()
            this.setAeraLayer()
            if (!this.tipsNotify) {
                // this.openNotify()
            }
        },
        // 开启/关闭 地图事件
        addControl(type, open = true) {
            if (open) {
                this.map.on(type, this.mapEvent)
            } else {
                this.map.off(type, this.mapEvent)
            }
        },
        // 监听地图缩放 结束触发
        mapEvent(e) {
            if (e.type == 'zoomend') {
                let zoom = this.map.getZoom()
                if (this.currMouseInfo.zoom == this.mapZoom) {
                    this.currMouseInfo.zoom = zoom
                    return
                }

                // 高亮图层显隐
                if (zoom > 7 && zoom <= 10) {
                    this.layerList[3] && this.map.remove(this.layerList[3].layer)
                    this.hlLayer && this.hlLayer.setMap(null)
                } else if (zoom > 10) { // 显示图标点
                    this.layerList[3] && this.map.add(this.layerList[3].layer)
                    this.hlLayer && this.hlLayer.setMap(this.map)
                }

                // // 图层数据更新
                // let down = (zoom - this.currMouseInfo.zoom) > 0
                // this.currMouseInfo.down = down
                // this.currMouseInfo.zoom = zoom
                // let drill = this.channelName == '' ? this.prevFeature.length : this.channelMapInfo.prevFeature.length
                // if (drill) {// 点击下钻后 层级缩放处理
                //     if (down) { // 下钻
                //         if (zoom >= 7 && zoom < 10) {// 省级
                //             // if(this.listParams.level == 0){

                //             // }
                //         } else if (zoom >= 10 && zoom < 12) { // 市级
                //             if (this.listParams.level == 1) {
                //                 this.currFeature = this.channelName == '' ? this.prevFeature[0] : this.channelMapInfo.prevFeature[0]
                //                 this.refreshMap('down')
                //             }
                //         } else if (zoom > 12) { // 区级 显示图标点
                //             if (this.listParams.level == 2) {
                //                 this.currFeature = this.channelName == '' ? this.prevFeature[1] : this.channelMapInfo.prevFeature[1]
                //                 this.refreshMap('down')
                //             }
                //         }
                //     } else {// 返回上一级
                //         if (zoom < 7) {// 全国
                //             if (this.listParams.level == 1) {
                //                 this.$emit('toPrevLevel')
                //             }
                //         } else if (zoom >= 7 && zoom < 10) {// 省级
                //             if (this.listParams.level == 2) {
                //                 this.$emit('toPrevLevel')
                //             }
                //         } else if (zoom >= 10 && zoom < 12) { // 市级
                //             if (this.listParams.level == 3) {
                //                 this.$emit('toPrevLevel')
                //             }
                //         }
                //     }
                // } else {// 搜索定位后 层级缩放处理
                //     if (this.hlLayer) {
                //         let hlExtData = this.hlLayer.getExtData().properties
                //         let hlRow = hlExtData.externalAttributes
                //         let _this = this, coor = hlExtData.center || [hlRow.lng, hlRow.lat] || []
                //         if (this.currMouseInfo.info) {
                //             this.changeMapData()
                //         } else {
                //             this.map.getCity(function (info) {
                //                 _this.currMouseInfo.info = info
                //                 _this.currMouseInfo.areaInfo = {}
                //                 _this.searchAera('province')
                //             }, coor);
                //         }
                //     }
                // }

            }

        },
        // 定位 缩放处理 
        changeMapData() {
            let down = this.currMouseInfo.down, zoom = this.currMouseInfo.zoom
            if (down) { // 下钻
                if (zoom >= 7 && zoom < 10) {// 省级
                    // if(this.listParams.level == 0){

                    // }
                } else if (zoom >= 10 && zoom < 12) { // 市级
                    if (this.listParams.level == 1) {
                        this.currFeature = this.channelName == '' ? this.prevFeature[0] : this.channelMapInfo.prevFeature[0]
                        this.refreshMap('down')
                    }
                } else if (zoom > 12) { // 区级 显示图标点
                    if (this.listParams.level == 2) {
                        this.currFeature = this.channelName == '' ? this.prevFeature[1] : this.channelMapInfo.prevFeature[1]
                        this.refreshMap('down')
                    }
                }
            } else {// 返回上一级
                if (zoom < 7) {// 全国
                    if (this.listParams.level == 1) {
                        this.$emit('toPrevLevel')
                    }
                } else if (zoom >= 7 && zoom < 10) {// 省级
                    if (this.listParams.level == 2) {
                        this.$emit('toPrevLevel')
                    }
                } else if (zoom >= 10 && zoom < 12) { // 市级
                    if (this.listParams.level == 3) {
                        this.listParams.code = this.currMouseInfo.areaInfo.district
                        let row = {
                            type: 'town',
                            name: this.currMouseInfo.info.district,
                            level: 3,
                        }
                        this.refreshMap()
                    }
                }
            }
        },
        // 查询区域
        searchAera(levelType) {
            var districtSearch = new AMap.DistrictSearch({
                level: levelType,
                subdistrict: 0,
            })

            // 搜索所有省/直辖市信息
            let _this = this, keyW = this.currMouseInfo.info[levelType]
            districtSearch.search(keyW, function (status, result) {
                if (status == 'complete') {
                    _this.currMouseInfo.areaInfo[levelType] = result.districtList[0].adcode
                    if (levelType == 'province') {
                        if (_this.currMouseInfo.info.city) {
                            _this.searchAera('city')
                        } else {
                            _this.searchAera('district')
                        }
                    } else if (levelType == 'city') {
                        _this.searchAera('district')
                    } else if (levelType == 'district') {
                        _this.changeMapData()
                    }
                }
            })

        },
        // 设置区域图层
        setAeraLayer() {
            this.disCountry && this.disCountry.setMap(null);
            let code = this.listParams.code
            let level = this.listParams.level
            if (code == '') {
                this.disCountry = new AMap.DistrictLayer.Country({
                    zIndex: 1,
                    SOC: 'CHN',
                    depth: 1,
                    styles: {
                        'nation-stroke': '#f09',
                        'coastline-stroke': '#ddd',
                        'province-stroke': '#333',
                        'fill': '#f2f2fc'
                    }
                })
            } else {
                this.disCountry = new AMap.DistrictLayer.Province({
                    zIndex: 1,
                    adcode: [code],
                    depth: level > 2 ? 2 : 1,
                    styles: {
                        'province-stroke': '#673ab7',
                        'city-stroke': level > 2 ? '#333' : '#673ab7',
                        'county-stroke': level > 2 ? '#333' : '#673ab7',
                        'fill': level > 2 ? '' : '#f5f5f5'
                    }
                })
            }
            this.disCountry.setMap(this.map)
        },
        // 获取图层数据
        getLayerList() {
            if (this.infoWindow) {
                this.infoWindow.close()
                this.currFeature = null
                this.options = null
            }

            getOrgMapData(this.listParams).then(res => {
                let mapData = res.data
                this.layerData = mapData
                for (var l in mapData) {
                    (() => {
                        this.addLayer(mapData[l].mapData, l)
                    })()
                }
                // this.$emit('openLoading', false)
            })
        },
        // 添加图层
        addLayer(layerData, type) {
            let isExit = false
            let layer = null
            if (this.layerList.length > 0) {
                this.layerList.map(item => {
                    if (item.id == type && item.layer) {
                        isExit = true
                        layer = item.layer
                    }
                })
            }
            if (isExit) {
                layer.importData(layerData)
                if (type == 4) {
                    this.map.add(layer)
                }
            } else {
                if (layerData.length == 0) return
                layer = new AMap.GeoJSON({
                    geoJSON: layerData,
                    getMarker: this.setLayerStyle,
                    getPolygon: this.setLayerStyle,
                });

                if (this.layerList.length > 0) {
                    this.layerList = this.layerList.map(item => {
                        if (item.id == type) {
                            if (item.layer == undefined) {
                                item.layer = layer
                                item.visible && this.map.add(layer);
                            }
                        }

                        return item
                    })
                }
            }
            // 设置高亮及详情
            if (this.toFit && !this.isSearchPosit) {
                let toSet = false
                if (this.listParams.type.indexOf(2) > -1) {
                    if (type == 2) {
                        toSet = true
                    }
                } else {
                    if (this.listParams.type.indexOf(3) > -1) {
                        toSet = true
                    }
                }
                if (toSet) {
                    this.setHeightlightLayer(layerData.features[0])
                    let rows = layerData.features[0].properties
                    let row = setBaseInfo(rows.externalAttributes, type)
                    row.id = row.idCard || row.damId
                    this.$emit('changeDetail', row)
                }
            }
        },
        // 高亮图层
        setHeightlightLayer(feature) {
            this.hlLayer && this.hlLayer.setMap(null)
            let pros = feature.properties
            let coor = feature.geometry.coordinates
            let mark = new AMap.Marker({
                zIndex: 30,
                position: coor,
                anchor: 'top-center',
                offset: [0, 10],
                content: `<img class="mark_icon" src="${require('@/assets/map/point_act.png')}" />`,
                cursor: 'pointer',
                clickable: true,
                extData: {
                    id: 'hLM',
                    properties: pros
                },
            })
            mark.on('click', this.showInfoOver)
            this.hlLayer = mark
            this.map.setZoomAndCenter(12, coor)
            if (pros.externalAttributes.rank == undefined) {
                this.hlLayer.setMap(this.map)
            }
        },
        // 设置图层样式
        setLayerStyle(feature, lnglats) {
            let pros = feature.properties
            let type = pros.externalAttributes.type
            let level = pros.externalAttributes.level
            let fetch = null
            let geomType = feature.geometry.type
            if (geomType == 'Point' || geomType == 'MultiPoint') {
                let coors = feature.geometry.coordinates
                if (type == 1) {
                    fetch = new AMap.Marker({
                        position: coors,
                        anchor: 'top-center',
                        offset: [0, 10],
                        content: `<div class="map_icon_label"><img class="label_icon" src="${require('@/assets/map/point_jjr.png')}" /><div class='label_info'>${changeNum(pros.externalAttributes.medBrokerNum)}</div></div>`, //设置文本标注内容
                        cursor: 'pointer',
                        clickable: true,
                        topWhenClick: true,
                        extData: {
                            properties: pros
                        }
                    })
                } else if (type == 2) {
                    let content = `<img class="mark_icon" src="${pros.externalAttributes.terminalType == '第二终端' ? require('@/assets/map/point_zd_2.png') : require('@/assets/map/point_zd.png')}" />`
                    let zIndex = 12
                    let rank = pros.externalAttributes.rank
                    if (rank) {
                        content = rank == -1 ? `<img class="mark_icon" src="${require('@/assets/map/point_6.png')}" />` : `<img class="mark_icon" src="${require('@/assets/map/point_' + rank + '.png')}" />`
                        zIndex = rank == -1 ? 13 : 13 + rank
                        rank == 1 && this.setHeightlightLayer(feature)
                    }

                    fetch = new AMap.Marker({
                        zIndex: zIndex,
                        position: coors,
                        anchor: 'top-center',
                        offset: [0, 10],
                        content: content,
                        cursor: 'pointer',
                        clickable: true,
                        topWhenClick: true,
                        extData: {
                            properties: pros
                        },
                    })

                } else if (type == 3) {
                    if (level >= 3) {
                        let zIndex = 12
                        let content = `<img class="mark_icon" src="${pros.externalAttributes.isMember == '是' ? require('@/assets/map/point_qd_ssas.png') : require('@/assets/map/point_qd_not.png')}" />`
                        let rank = pros.externalAttributes.rank
                        if (rank) {
                            content = rank == -1 ? `<img class="mark_icon" src="${require('@/assets/map/point_6.png')}" />` : `<img class="mark_icon" src="${require('@/assets/map/point_' + rank + '.png')}" />`
                            zIndex = rank == -1 ? 13 : 13 + rank
                            rank == 1 && this.setHeightlightLayer(feature)
                        }
                        fetch = new AMap.Marker({
                            position: coors,
                            zIndex: zIndex,
                            anchor: 'top-center',
                            offset: [0, 10],
                            content: content,
                            cursor: 'pointer',
                            clickable: true,
                            topWhenClick: true,
                            extData: {
                                properties: pros
                            }
                        })

                    } else {
                        fetch = new AMap.CircleMarker({
                            center: coors,
                            radius: 4,
                            strokeColor: '#5797FF',
                            strokeWeight: 1,
                            strokeOpacity: 0.8,
                            fillColor: '#5797FF',
                            fillOpacity: 0.8,
                            cursor: 'pointer',
                            extData: {
                                properties: pros
                            }
                        })
                    }
                }
            } else if (geomType == 'Polygon' || geomType == 'MultiPolygon') {
                let code = 0
                code = pros.externalAttributes.terminalNum ? pros.externalAttributes.terminalNum : 0
                let min = formatInt(this.layerData[2].minValue, true)
                let max = formatInt(this.layerData[2].maxValue, true)
                let minValue = this.layerData[2].minValue <= 10 ? 10 : min
                let maxValue = this.layerData[2].maxValue <= 50 ? 50 : max
                let color = setColor(code, minValue, maxValue);
                let per = Math.ceil((maxValue - minValue) / 6);
                let rang = [
                    changeNum(minValue),
                    changeNum(minValue + per),
                    changeNum(minValue + per * 2),
                    changeNum(minValue + per * 3),
                    changeNum(minValue + per * 4),
                    changeNum(minValue + per * 5),
                    changeNum(maxValue)
                ]
                this.$emit('setColorRang', rang)

                fetch = new AMap.Polygon({
                    path: lnglats,
                    zIndex: 5,
                    fillOpacity: 0.7,
                    strokeColor: '#909090',
                    strokeWeight: 1,
                    strokeOpacity: 0.7,
                    fillColor: color,
                    extData: {
                        properties: pros
                    }
                });
            }

            fetch.on('click', this.showInfoOver);
            // if (type != 3 && level <= 3) {
            //     fetch.on('dblclick', this.showInfoOver);
            // }

            return fetch
        },
        // 获取要素关联图层数据
        getDetailLayer(row) {
            let id = row.id
            let type = row.type
            if (typeof (row.name) != 'undefined') {
                this.channelName = row.name
            }
            this.isSearchPosit = row.toPosit ? row.toPosit : false
            if (row.toPosit) {
                this.layerList[3] && this.map.remove(this.layerList[3].layer)
                this.hlLayer && this.hlLayer.setMap(null)
            }
            if (type == 1) {
                if (this.channelName == '' || row.toPosit) {
                    // 业务员详情
                    getVisitMapData({ idCard: id }).then(res => {
                        let data = res.data
                        if (row.toPosit) {
                            if (data.firstIndex == -1) {
                                this.$message('该数据暂无拜访位置信息');
                            } else {
                                // this.setHeightlightLayer(data.mapData.features[data.firstIndex])
                            }
                        }

                        if (this.layerList[3]) {
                            this.map.remove(this.layerList[3].layer)
                            this.hlLayer && this.hlLayer.setMap(null)
                        } else {
                            this.layerList.push({
                                id: 4,
                                name: '拜访客户',
                                visible: true,
                            })
                        }
                        this.addLayer(data.mapData, 4)
                    })
                } else {
                    // 返回到会员渠道
                    this.refreshMap('detail')
                }
            } else {
                if (row.toPosit) {
                    if (row.code) {
                        // 终端、渠道搜索定位
                        getPointMapData({ damId: id, type: type }).then(res => {
                            let data = res.data
                            // 设置高亮
                            this.setHeightlightLayer(data.mapData.features[0])
                        })
                        this.listParams.code = row.code
                        this.listParams.level = row.level
                        this.getLayerList()
                    } else {
                        this.$message('该数据暂无位置信息');
                    }
                } else {
                    if (this.channelName != '') {
                        // 会员渠道关联人员及终端
                        this.listParams.code = ''
                        this.listParams.level = 0
                        this.listParams.damId = id
                        this.getLayerList()
                        this.$emit('changeDetail', this.listParams, { prev: '全国', curr: '全国' })
                        if (this.listParams.code == '') {
                            this.map.setZoomAndCenter(this.mapZoom, this.mapCenter)
                        }
                    } else {
                        // 返回到会员渠道
                        this.refreshMap('detail')
                    }
                }
            }
        },
        // 图层显隐
        changeLayerVisible() {
            if (this.layerList.length > 0) {
                this.layerList.map(item => {
                    if (item.layer) {
                        item.visible ? this.map.add(item.layer) : this.map.remove(item.layer)
                    }
                })
            }
        },
        // 显示气泡
        showInfoOver(evt) {
            if (this.currFeature == null) {
                let polygon = evt.target
                let polygonType = polygon.type
                let extData = polygon.getExtData().properties
                let row = extData.externalAttributes
                let type = row.type
                let level = row.level
                row = setBaseInfo(row, type)
                this.popupInfo = JSON.parse(JSON.stringify(row))

                this.options = polygon.getOptions()
                if (polygonType.indexOf('Marker') > -1 && type != 1) {
                    if (this.hlLayer && !polygon.getExtData().id) {
                        let hlExtData = this.hlLayer.getExtData().properties
                        let hlRow = hlExtData.externalAttributes
                        let hlType = hlRow.type
                        let hlContent = `<img class="mark_icon" src="${require('@/assets/map/point_act.png')}" />`
                        if (hlType == 2) {
                            hlContent = `<img class="mark_icon" src="${hlRow.terminalType == '第二终端' ? require('@/assets/map/point_zd_2.png') : require('@/assets/map/point_zd.png')}" />`
                            let rank = hlRow.rank
                            if (rank) {
                                hlContent = rank == -1 ? `<img class="mark_icon" src="${require('@/assets/map/point_6.png')}" />` : `<img class="mark_icon" src="${require('@/assets/map/point_' + rank + '.png')}" />`
                            }
                        } else if (hlType == 3) {
                            hlContent = `<img class="mark_icon" src="${hlRow.isMember == '是' ? require('@/assets/map/point_qd_ssas.png') : require('@/assets/map/point_qd_not.png')}" />`
                        }
                        this.hlLayer.setOptions({
                            content: hlContent,
                        })
                    }
                    polygon.setOptions({
                        content: `<img class="mark_icon" src="${require('@/assets/map/point_act.png')}" />`
                    })

                    if (level >= 3 && this.channelName == '') {
                        this.channelMapInfo.params = this.listParams
                        this.channelMapInfo.data = row
                        let info = JSON.parse(JSON.stringify(row))
                        info.id = row.idCard || row.damId
                        this.$emit('changeDetail', info)
                    }
                } else {
                    polygon.setOptions({
                        fillColor: '#83C0FF'
                    })
                }

                if (type == 2 || type == 3) {
                    let list = [
                        { field: 'newestMaintainTime', label: '近期拜访时间', value: row.newestMaintainTime },
                        { field: 'newestMaintainStaffName', label: '服务人员', value: row.newestMaintainStaffName },
                    ]
                    this.popupInfo.list = list
                }

                this.currFeature = polygon
                let posit = extData.center || [row.lng, row.lat] || []
                this.$nextTick(() => {
                    let content = this.$refs.popup1.outerHTML
                    this.infoWindow = new AMap.InfoWindow({
                        content: content
                    });

                    this.infoWindow.open(this.map, posit);
                    if (level < 3) {
                        if (type == 3) {
                            this.toDetail(type, row)
                        } else {
                            this.mapDrill(feature)
                        }
                    } else {
                        this.toDetail(type, row)
                        this.backDetail()
                    }
                })
            } else {
                this.currFeature.setOptions(this.options)
                this.currFeature = null
                this.showInfoOver(evt)
            }
        },
        // 地图下钻
        mapDrill() {
            let _this = this
            const btn = document.querySelectorAll('.drill_btn')
            btn[0].onclick = (e) => {
                //在这里做点击的操作
                _this.refreshMap('down')
            }
        },
        // 返回上一层级
        refreshMap(type, info) {
            let extData = { externalAttributes: { level: -1 }, adcode: '', name: '全国' }
            if (type == 'down') {
                extData = info ? info : this.currFeature.getExtData().properties
            } else if (type == 'detail') {
                extData = this.channelMapInfo.prevFeature.at(-1).getExtData().properties
            } else {
                if (type.level == 'town') {
                    this.layerList[3] && this.map.remove(this.layerList[3].layer)
                    this.hlLayer && this.hlLayer.setMap(null)
                    if (this.toFit) {
                        this.refreshMap({ level: 'dist', name: type.name, toFit: 'fit' })
                        return
                    } else {
                        if (this.channelName == '') {
                            if (this.prevFeature.length <= 2) {
                                extData = typeof (this.prevFeature[1].name) != 'undefined' ? this.prevFeature[1] : this.prevFeature[1].getExtData().properties
                            } else {
                                extData = typeof (this.prevFeature[2].name) != 'undefined' ? this.prevFeature[2] : this.prevFeature[2].getExtData().properties
                            }
                        } else {
                            if (this.channelMapInfo.prevFeature.length <= 2) {
                                extData = typeof (this.channelMapInfo.prevFeature[1].name) != 'undefined' ? this.channelMapInfo.prevFeature[1] : this.channelMapInfo.prevFeature[1].getExtData().properties
                            } else {
                                extData = typeof (this.channelMapInfo.prevFeature[2].name) != 'undefined' ? this.channelMapInfo.prevFeature[2] : this.channelMapInfo.prevFeature[2].getExtData().properties
                            }
                        }
                    }
                } else if (type.level == 'dist') {
                    if (this.channelName == '') {
                        if (type.name.indexOf('北京') > -1 || type.name.indexOf('天津') > -1 || type.name.indexOf('上海') > -1 || type.name.indexOf('重庆') > -1) {
                            extData = typeof (this.prevFeature[0].name) != 'undefined' ? this.prevFeature[0] : this.prevFeature[0].getExtData().properties
                        } else {
                            extData = typeof (this.prevFeature[1].name) != 'undefined' ? this.prevFeature[1] : this.prevFeature[1].getExtData().properties
                        }
                    } else {
                        if (type.name.indexOf('北京') > -1 || type.name.indexOf('天津') > -1 || type.name.indexOf('上海') > -1 || type.name.indexOf('重庆') > -1) {
                            extData = typeof (this.channelMapInfo.prevFeature[0].name) != 'undefined' ? this.channelMapInfo.prevFeature[0] : this.channelMapInfo.prevFeature[0].getExtData().properties
                        } else {
                            extData = typeof (this.channelMapInfo.prevFeature[1].name) != 'undefined' ? this.channelMapInfo.prevFeature[1] : this.channelMapInfo.prevFeature[1].getExtData().properties
                        }
                    }
                } else if (type.level == 'city') {
                    if (type.name != '全国') {
                        if (type.name.indexOf('北京') > -1 || type.name.indexOf('天津') > -1 || type.name.indexOf('上海') > -1 || type.name.indexOf('重庆') > -1) {
                            if (this.channelName == '') {
                                extData = typeof (this.prevFeature[0].name) != 'undefined' ? this.prevFeature[0] : this.prevFeature[0].getExtData().properties
                            } else {
                                extData = typeof (this.channelMapInfo.prevFeature[0].name) != 'undefined' ? this.channelMapInfo.prevFeature[0] : this.channelMapInfo.prevFeature[0].getExtData().properties
                            }
                        } else {
                            if (this.channelName == '') {
                                extData = typeof (this.prevFeature[0].name) != 'undefined' ? this.prevFeature[0] : this.prevFeature[0].getExtData().properties
                            } else {
                                extData = typeof (this.channelMapInfo.prevFeature[0].name) != 'undefined' ? this.channelMapInfo.prevFeature[0] : this.channelMapInfo.prevFeature[0].getExtData().properties
                            }
                        }
                    }
                }
            }

            let row = extData.externalAttributes
            let level = row.level
            let distName = extData.name || '全国'
            let prev = '全国'
            if (type == 'down') {
                this.listParams.level = level + 1
                this.listParams.code = extData.adcode
                // 渠道关联数据下钻 不更新
                if (this.channelName == '') {
                    if (this.prevFeature.length) {
                        let name = this.prevFeature[0].name || this.prevFeature[0].getExtData().properties.name
                        // 直辖市
                        if (name.indexOf('北京') > -1 || name.indexOf('天津') > -1 || name.indexOf('上海') > -1 || name.indexOf('重庆') > -1) {
                            if (level == 2 && level >= this.prevFeature.length) {
                                prev = this.prevFeature[level - 2].name || this.prevFeature[level - 2].getExtData().properties.name
                                this.prevFeature[level - 1] = info ? info : this.currFeature
                            } else {
                                prev = this.prevFeature[level - 1].name || this.prevFeature[level - 1].getExtData().properties.name
                                this.prevFeature[level] = info ? info : this.currFeature
                            }
                        } else {
                            prev = this.prevFeature[level - 1].name || this.prevFeature[level - 1].getExtData().properties.name
                            this.prevFeature[level] = info ? info : this.currFeature
                        }
                    } else {
                        this.prevFeature[level] = info ? info : this.currFeature
                    }
                } else {
                    prev = this.channelMapInfo.prevFeature.length ? (this.channelMapInfo.prevFeature[level - 1].name || this.channelMapInfo.prevFeature[level - 1].getExtData().properties.name) : '全国'
                    if (level == this.channelMapInfo.prevFeature.length) {
                        this.channelMapInfo.prevFeature[level] = info ? info : this.currFeature
                    } else {
                        this.channelMapInfo.prevFeature[level - 1] = info ? info : this.currFeature
                    }
                }
            } else if (type == 'detail') {
                this.listParams = this.channelMapInfo.params
                prev = extData.name
            } else {
                this.listParams.level = level + 1
                this.listParams.code = extData.adcode
                if (type.level == 'town') {
                    if (this.prevFeature.length <= 2) {
                        prev = this.channelName == '' ? (this.prevFeature[0].name || this.prevFeature[0].getExtData().properties.name) : (this.channelMapInfo.prevFeature[0].name || this.channelMapInfo.prevFeature[0].getExtData().properties.name)
                    } else {
                        prev = this.channelName == '' ? (this.prevFeature[1].name || this.prevFeature[1].getExtData().properties.name) : (this.channelMapInfo.prevFeature[1].name || this.channelMapInfo.prevFeature[1].getExtData().properties.name)
                    }
                } else if (type.level == 'dist') {
                    if (type.name.indexOf('北京') == -1 && type.name.indexOf('天津') == -1 && type.name.indexOf('上海') == -1 && type.name.indexOf('重庆') == -1) {
                        prev = this.channelName == '' ? (this.prevFeature[0].name || this.prevFeature[0].getExtData().properties.name) : (this.channelMapInfo.prevFeature[0].name || this.channelMapInfo.prevFeature[0].getExtData().properties.name)
                    }
                }
                if (this.listParams.code == '') {
                    if (this.channelName == '') {
                        this.prevFeature = []
                    } else {
                        this.channelMapInfo.prevFeature = []
                    }
                }
            }

            this.toFit = (this.listParams.level > 2 && this.listParams.type.indexOf(1) == -1 && (type == 'down' || type == 'detail' || type.level == 'town'))
            this.getLayerList()
            this.$emit('changeDetail', this.listParams, { prev: prev, curr: distName, down: type == 'down' || type == 'detail', toFit: type.toFit || this.toFit })

            if (this.listParams.code == '') {
                this.map.setZoomAndCenter(this.mapZoom, this.mapCenter)
            } else {
                this.map.setCity(extData.adcode)
            }

            this.setAeraLayer()
        },
        // 回到详情 
        backDetail() {
            let _this = this
            const btn = document.querySelectorAll('.to_detail')
            btn.forEach(ele => {
                ele.onclick = (e) => {
                    if (e.target.className.indexOf('to_term') > -1) {// 返回服务人员详情
                        let info = JSON.parse(JSON.stringify(_this.popupInfo))
                        info.id = info.newestMaintainStaffIdCard
                        info.type = 1
                        _this.$emit('backDetail', info)
                    } else {// 返回会员渠道详情
                        // _this.$emit('backDetail', 2)
                    }
                }
            })

        },
        // 跳转至详情页
        toDetail(type, row) {
            const btn = document.querySelectorAll('.to_detail_page')
            btn[0].onclick = (e) => {
                let info = setBaseInfo(row, type)
                let queryInfo = this.$route.query
                queryInfo.type = type
                queryInfo.data = JSON.stringify([info])
                queryInfo.from = 'home'
                queryInfo.toRoute = 'detail'
                let pathInfo = this.$router.resolve({
                    path: '/portrait/salesmanDetail',
                    query: queryInfo
                })
                window.open(pathInfo.href, '_blank');
            }
        },
    }
}
</script>

<style lang="less" scoped>
.map_panel,
.map_container {
    width: 100%;
    height: 100%;
}

/deep/.map_icon_label {
    display: flex;
    align-items: center;
    font-size: 16px;
    background: #FF854D;
    height: 24px;
    border: 1px solid #FF854D;
    border-radius: 2px;

    .label_icon {
        width: 20px;
        height: 20px;
        background: #FF854D;
        padding: 0 2px;
    }

    .label_info {
        padding: 0 10px;
        background: #fff;
        color: #FF854D;
        height: 100%;
        min-width: 40px;
    }
}

/deep/.mark_icon {
    width: 32px;
}

/deep/.amap-marker {
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}

.popup_title {
    width: 180px;
    display: flex;
    align-items: center;
    padding: 5px;

    &.plus {
        width: 300px;
    }

    .title_cont {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        text-align: left;
        font-size: 14px;

        .title_text {
            color: #212121;
            line-height: 24px;
            font-weight: 600;
        }

        .title_num {
            font-size: 16px;
            color: #999;
            text-align: right;
            line-height: 24px;
        }
    }
}

.popup_body {
    width: 300px;
}

.list_group {
    width: 100%;
    display: flex;
    text-align: left;
    cursor: default;
}

.plus .list_group {
    .group_title {
        &:hover {
            .title_text {
                color: #4FA1A4;
                cursor: pointer;
            }
        }
    }
}

.group_icon {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    background: #d9d9d9;
    color: #fff;
    margin: 5px 10px 0 0;

    &.one {
        background: #fb2323;
    }

    &.tow {
        background: #5797ff;
    }

    &.three {
        background: #ffd52e;
    }
}

.group_cont {
    width: 100%;

    .group_title {
        margin-bottom: 10px;

        .title_text {
            font-size: 14px;
            color: #212121;
            line-height: 30px;
            font-weight: 600;
        }

        .title_addr {
            font-size: 14px;
            color: #666666;
            line-height: 21px;
            font-weight: 400;
            margin-bottom: 10px;
        }

        .title_tags {
            font-size: 12px;

            span {
                display: inline-block;
                padding: 5px;
                background: #EBF6F7;
                border-radius: 2px;
                color: #4FA1A4;
                margin-right: 5px;
            }
        }
    }


    .list_panel {

        .list_item {
            display: flex;
            align-items: center;
            font-size: 12px;

            .item_title {
                color: #666;
                line-height: 20px;
            }

            .item_num {
                color: #212121;

                &.active {
                    color: #4FA1A4;
                    cursor: pointer;
                }
            }
        }
    }
}

.info_btns {
    text-align: right;
}

/deep/.amap-info-close {
    font-weight: normal;
    color: #666;
}

/deep/.amap-logo,
/deep/.amap-copyright {
    display: none !important;
}

/deep/.tips_panel {
    color: #212121;

    .panel_title {
        font-size: 16px;

        .title_icon {
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }
    }

    .panel_con {
        .close_btn {
            color: #4FA1A4;
        }
    }
}
</style>